import React from "react";
import {Field} from "formik";

export const InputField = (props) => (
    <Field className="form-control" {...props}/>
)

